import theme from 'src/theme';
import { durations } from '../background/styles';

export const duration = durations.images;
export const delay = durations.width;
export const durationEnd = delay + duration;

export default {
  panel: {
    display: 'flex',
    position: 'absolute',
    width: '100%',
    height: 0,
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },

  paperRoot: {
    ...(theme.mixins.animation.transition('bottom', 'width', 'height')),

    display: 'flex',
    position: 'absolute',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    bottom: -110,
    left: '50%',
    width: 320,
    height: 320,
    padding: [theme.spacing(2), 0],
    marginLeft: -160,
    boxSizing: 'border-box',
    overflow: 'hidden',

    [theme.breakpoints.down('md')]: {
      bottom: -60,
      width: 280,
      height: 280,
      marginLeft: -140,
    },

    [theme.breakpoints.down('sm')]: {
      bottom: -50,
      width: 250,
      height: 250,
      marginLeft: -125,
    },
  },

  progress: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
  },

  logo: {
    '@global svg': {
      fontSize: 96,
    },
  },

  welcome: {
    padding: [theme.spacing(1), 0],
  },

  title: {
    ...theme.typography.h6,
    color: theme.palette.primary.main,
  },

  button: {
    marginTop: theme.spacing(3),

    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(2),
    },
  },

  buttonLogo: {
    marginRight: theme.spacing(2),
  },

  error: {
    ...(theme.mixins.animation.transition('top')),

    position: 'absolute',
    top: 110,
    padding: theme.spacing(3),
    fontSize: 12,
    color: theme.palette.error.main,

    [theme.breakpoints.down('md')]: {
      top: 60,
    },

    [theme.breakpoints.down('sm')]: {
      top: 50,
    },
  },

  appear: {
    ...(theme.mixins.animation.transitionDuration(duration, 'transform', 'opacity')),
    transitionDelay: `${delay}ms`,

    transform: 'scale(0)',
    opacity: 0,
  },

  appearActive: {
    transform: 'scale(1)',
    opacity: 1,
  },
};
